import(/* webpackMode: "eager" */ "/var/www/heizos-build/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/heizos-build/src/components/Navbar.tsx");
